import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import { getContactInfo } from '@/api/index'
import { initSeo } from '@/utils/seo'
import './assets/styles/global.scss'

Vue.use(ElementUI, { size: 'medium' })
Vue.config.productionTip = false

async function bootstrap() {
  await initSeo(getContactInfo)
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()
